import { createSelector } from 'reselect';

import { getConfigurator } from './getConfigurator';

export const getWorkspace = createSelector(
  getConfigurator,
  configurator => configurator.workspace
);
